module.exports = __webpack_public_path__ + "img/Property 1=4x3, Property 2=BB - Barbados.c3e0fd76.svg";